import { Chart } from "./chart"
import { Rectangle } from "./core/primitives"
import { Slider } from "./slider"

/*
	Copyright 2010 by Robin W. Spencer
	http://scaledinnovation.com/analytics/splines/aboutSplines.html

	Modifications by Steema Software.

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
	GNU General Public License for more details.

	You can find a copy of the GNU General Public License
	at http://www.gnu.org/licenses/.
*/
let drawSpline = function drawSpline(ctx, pts, t, move, closed) {
	let cp = [];
	const n = pts.length;

	function point(x0, y0, x1, y1, x2, y2, tension) {
		function square(x) {
			return x * x;
		}

		const d = Math.sqrt(square(x1 - x0) + square(y1 - y0));
		const a = (tension * d) / (d + Math.sqrt(square(x2 - x1) + square(y2 - y1)));
		const b = tension - a;

		return [x1 + a * (x0 - x2), y1 + a * (y0 - y2), x1 - b * (x0 - x2), y1 - b * (y0 - y2)];
	}

	if (closed) {
		if (move) {
			ctx.moveTo(pts[0], pts[1]);
		}

		pts.push(pts[0], pts[1], pts[2], pts[3]);
		pts.unshift(pts[n - 1]);
		pts.unshift(pts[n - 1]);

		for (let i = 0; i < n; i += 2) {
			cp = cp.concat(point(pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5], t));
		}

		cp = cp.concat(cp[0], cp[1]);

		for (let i = 2; i < n + 2; i += 2) {
			ctx.bezierCurveTo(cp[2 * i - 2], cp[2 * i - 1], cp[2 * i], cp[2 * i + 1], pts[i + 2], pts[i + 3]);
		}
	} else {
		for (let i = 0; i < n - 4; i += 2) {
			cp = cp.concat(point(pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5], t));
		}

		if (move) {
			ctx.moveTo(pts[0], pts[1]);
		}

		ctx.quadraticCurveTo(cp[0], cp[1], pts[2], pts[3]);

		for (let i = 2; i < n - 5; i += 2) {
			ctx.bezierCurveTo(cp[2 * i - 2], cp[2 * i - 1], cp[2 * i], cp[2 * i + 1], pts[i + 2], pts[i + 3]);
		}

		ctx.quadraticCurveTo(cp[2 * n - 10], cp[2 * n - 9], pts[n - 2], pts[n - 1]);
	}
};

let Scroller = function (canvas, target) {
	Chart.call(this, canvas)

	this.target = target

	this.aspect.clip = false
	this.panel.transparent = true
	this.title.visible = false

	var scroller = (this.scroller = new Slider(this))
	scroller.useRange = true
	scroller.thumbSize = 100

	var u = scroller.thumb
	u.shadow.height = 0
	u.transparency = 0.6
	u.stroke.fill = "black"
	u.shadow.visible = false

	scroller.horizontal = true
	var b = scroller.bounds
	b.x = 0
	b.y = 0
	b.width = this.bounds.width
	b.height = this.bounds.height
	scroller.margin = 0

	scroller.lock = false

	this.tools.add(scroller)

	var o = this

	target.ondraw = () => {
		if (!scroller.lock) o.draw()
	}
	target.onscroll = function () {
		var a = this.axes.bottom,
			li = this.series,
			mi = li.minXValue(),
			ma = li.maxXValue(),
			dif = a.maximum - a.minimum

		if (a.minimum < mi) {
			a.minimum = mi
			a.maximum = a.minimum + dif
		}
		if (a.maximum > ma) {
			a.maximum = ma
			a.minimum = a.maximum - dif
		}
	}

	this.useRange = function (value) {
		scroller.useRange = value
		this.draw()
	}

	this.invertThumb = function (value) {
		scroller.invertThumb = value
		this.draw()
	}

	scroller.onChanging = function (s, v) {
		var r = ((s.thumbSize * (s.max - s.min)) / s.bounds.width) * 0.5,
			li = target.series,
			mi = li.minXValue(),
			ma = li.maxXValue()

		if (v - r < mi) v = mi + r
		else if (v + r > ma) v = ma - r

		target.axes.bottom.setMinMax(v - r, v + r)
		this.lock = true

		//requestAnimationFrame(function() {target.draw();});

		target.draw()
		this.lock = false

		if (o.onChanging) o.onChanging(o, v - r, v + r)

		return v
	}

	this.setBounds = function (x, y, width, height) {
		this.bounds.x = x
		this.bounds.y = y
		this.bounds.width = width
		this.bounds.height = height

		b.x = x
		b.y = y
		b.width = width
		b.height = height
	}

	scroller.onDrawThumb = s => {
		var r = target.chartRect,
			ctx = target.ctx
		var cRect = new Rectangle(scroller.bounds.x, scroller.bounds.y, scroller.bounds.width, scroller.bounds.height)
		target.chartRect = cRect
		target.ctx = scroller.chart.ctx

		function saveAxis(axis, data) {
			var res = {
				mi: axis.minimum,
				ma: axis.maximum,
				sp: axis.startPos,
				ep: axis.endPos
			}
			restoreAxis(axis, data)
			return res
		}

		function restoreAxis(axis, old) {
			axis.minimum = old.mi
			axis.maximum = old.ma
			axis.startPos = old.sp
			axis.endPos = old.ep
			axis.scale = (old.ep - old.sp) / (old.ma - old.mi)
		}

		var b = scroller.bounds,
			c = target,
			li = c.series,
			h,
			v

		s.min = li.minXValue()
		s.max = li.maxXValue()

		h = saveAxis(c.axes.bottom, {
			sp: b.x,
			ep: b.x + b.width,
			mi: s.min,
			ma: s.max
		})
		v = saveAxis(c.axes.left, {
			sp: b.y,
			ep: b.y + b.height,
			mi: li.minYValue(),
			ma: li.maxYValue()
		})

		var p = (h.mi + h.ma) * 0.5,
			dif = h.ma - h.mi,
			ra

		//if (s.position!=p) {
		s.thumbSize = (dif * s.bounds.width) / (s.max - s.min)
		ra = dif * 0.5
		if (o.onChanging) o.onChanging(o, p - ra, p + ra)
		s.position = p
		//}

		c.series.each(s => {
			if (s.visible && s.useAxes) {
				if (s.pointer != undefined) {
					//disable points in Scroller. Bug sizing
					var oldVisible = s.pointer.visible
					s.pointer.visible = false
					s.draw()
					s.pointer.visible = oldVisible
				} else s.draw()
			}
		})

		restoreAxis(c.axes.bottom, h)
		restoreAxis(c.axes.left, v)

		c.chartRect = r
		c.ctx = ctx
	}
}

Scroller.prototype = new Chart()

let SliderControl = canvas => {
	var tmp = new Chart(canvas)
	tmp.panel.transparent = true
	tmp.title.visible = false

	var s = new Slider(tmp)

	s.bounds.x = s.thumbSize + 1
	s.bounds.width = tmp.canvas.width - 2 * s.thumbSize - 2
	s.bounds.y = (tmp.canvas.height - s.bounds.height) * 0.5

	tmp.tools.add(s)
	return s
}

export { drawSpline, Scroller, SliderControl }

